export function getCompanies() {
  return {
    type: 'GET_COMPANIES',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/billing/companies',
            mock: false,
          },
        },
        commit: {
          type: `GET_COMPANIES_COMMIT`,
        },
        rollback: {
          type: 'GET_COMPANIES_ROLLBACK',
        },
      },
    },
  }
}
